export const SORT_OPTIONS = {
    POPULAR: 'sortPopular',
    PRICE_ASC: 'sortPriceAsc',
    PRICE_DESC: 'sortPriceDesc',
    DISCOUNT_PERCENT_DESC: 'sortDiscountPercentDesc',
    NEWEST_DESC: 'sortNewestDesc',
    RATINGS_DESC: 'sortRatingsDesc',
} as const;

export type SortOption = (typeof SORT_OPTIONS)[keyof typeof SORT_OPTIONS];
